import component from './GroupCreation';
import container from './GroupCreation.container';
export default container(component);
